import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/BreedGlossary/breedGlossary.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Breeds/useCases/useBreedFilter.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Breeds/useCases/useBreedSearch.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Checkout/useCases/useCart.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Ongs/useCases/useFilter.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Ongs/useCases/useOngFilters.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/Ongs/useCases/useProductList.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/ProductItem/useCases/useFastBuy.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/ProductItem/useCases/useFastBuyButton.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/ProductItem/useCases/useSliderSkus.ts");
;
import(/* webpackMode: "eager" */ "/app/src/domain/ProductItem/useProductItem.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/Base/index.tsx");
